export default "__VITE_ASSET__BFGTRGlZ__"